import { render, staticRenderFns } from "./comp_Hook-ProductPage-DescriptionAndAttrs.vue?vue&type=template&id=eb4e38dc&scoped=true&"
import script from "./comp_Hook-ProductPage-DescriptionAndAttrs.vue?vue&type=script&lang=js&"
export * from "./comp_Hook-ProductPage-DescriptionAndAttrs.vue?vue&type=script&lang=js&"
import style0 from "./comp_Hook-ProductPage-DescriptionAndAttrs.vue?vue&type=style&index=0&id=eb4e38dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4e38dc",
  null
  
)

export default component.exports